import Notify from "./../notify"
import CustomSelect from "./select";
export default class ObjectsFilter {
    constructor() {
        this.data = {
            status: "",
            name: "",
            number: "",
            location: "",
        }
        this.paginationBtn = "#event-pagination-button-ajax";
        this.paginationContainer = "#events-pagination-ajax";
        this.contanerCollection = "#objects-list";
        this.ajaxUrl = "/themes/ahtilahti/ajax/object-list.php";

    }
    search(url = false, pagination) {
        var instance = this;
        if (url && url !== 'undefined') {
            var ajaxUrl = url;
        } else {
            var ajaxUrl = this.ajaxUrl;
        }
        $.ajax({
            method: "POST",
            url: ajaxUrl,
            async: false,
            data: {
                action: "search_objects",
                status: this.data.status,
                name: this.data.name,
                nubmer: this.data.number,
                location: this.data.location
            },
            success: function(response) {

                if (pagination) {
                    pagination = $(response).find(instance.paginationContainer).html();
                    let items = $(response).html();
                    $(instance.contanerCollection).append(items);
                    $(instance.paginationContainer).empty();
                    $(instance.paginationContainer).append(pagination);

                    // instance.scrollViewItems();
                } else {

                    $("#container-arend-objects").html(response);



                }
            },
            error(xhr, status, error) {

                new Notify($.parseJSON(xhr.responseText).message, "alert");
            }
        });

        setTimeout(function() {

            instance.scrollViewItems();
        }, 100)


    }

    scrollViewItems() {

        let instance = this;

        var containerItems = document.getElementsByClassName(
            "events-list-container"
        );
        if (containerItems.length) {
            var lastElement =
                containerItems[0].children[containerItems[0].children.length - 1];

            let href = $("#event-pagination-button-ajax").attr("href");
            if (instance.isVisible(lastElement) && href !== undefined) {

                let url = instance.ajaxUrl + href;
                instance.search(url, true);

            }

            window.addEventListener("scroll", function() {
                let href = $("#event-pagination-button-ajax").attr("href");
                let url = instance.ajaxUrl + href;
                var lastElement =
                    containerItems[0].children[containerItems[0].children.length - 1];

                if (instance.isVisible(lastElement) && href !== undefined) {
                    instance.search(url, true);
                }
            });
        }

    }

    // againSearch() {
    //     let href = $("#event-pagination-button-ajax").attr("href");
    //     let url = instance.ajaxUrl + href;
    //     instance.search(url, true);


    // }
    isVisible(element) {
        var w = window;
        var wt = w.pageYOffset;
        var lt = element.offsetTop;
        var lb = lt + element.clientHeight;

        return lb <= wt + w.innerHeight && lt >= wt;
    }
    pagination() {
        let instance = this;

        $(document).on("click", "#event-pagination-button-ajax", function(e) {
            let href = $(this).attr("href");

            e.preventDefault();

            let url = instance.ajaxUrl + href;
            instance.search(url, true);
        });

        instance.scrollViewItems();
    }
    init() {
        this.pagination();
        let instance = this;

        $(document).on("change", "#objects-select-status", function(e) {
            e.preventDefault();
            instance.data.status = $(this).val();
            instance.search();

            // instance.againSearch();

        });
        $(document).on("change", "#select-sort-name", function(e) {
            e.preventDefault();
            instance.data.name = $(this).val();
            instance.search();


        });

        $(document).on("change", "#select-sort-number", function(e) {
            e.preventDefault();
            instance.data.number = $(this).val();
            instance.search();


        });

        if ($("#location-select-object").length) {
            const select2 = new CustomSelect('#location-select-object');
        }


        $(document).on("select.change keyup", "#location", function(e) {
            e.preventDefault();
            instance.data.location = $(this).val();
            instance.search();


        });


        $("#location-select-object .select__item").on("click", function(e) {

            e.preventDefault();
            instance.data.location = $(this).attr("value");
            instance.search();


        });



    }
}